@include host-component-properties;

:host {
  --paf-radio-checkbox-group-legend-font-size: 24;
  --paf-radio-checkbox-group-legend-font-weight: 700;
  --paf-radio-checkbox-group-legend-color: var(--paf-global-post-brand-dark);
  --paf-radio-checkbox-group-legend-margin-block-end: 12;
  --paf-radio-checkbox-group-legend-padding-inline-end: 12;
  --paf-radio-checkbox-group-button-font-size: 16;
  --paf-radio-checkbox-group-button-padding-block: 12;
  --paf-radio-checkbox-group-button-padding-inline: 4;
  --paf-radio-checkbox-group-column-gap: 16;
  --paf-radio-checkbox-group-transition-duration: 180ms;
  --paf-radio-checkbox-group-button-color: var(--paf-global-post-brand-secondary);
  --paf-radio-checkbox-group-button-color-active: var(--paf-global-post-brand-black);
  --paf-radio-checkbox-group-toggle-row-gap: 16;

  & ::slotted(paf-radio-checkbox) {
    display: block;
    flex-basis: 100%;
    max-width: 100%;

    @include mq($from: medium) {
      flex-basis: calc(50% - px-to-rem(var(--paf-radio-checkbox-group-column-gap)));
      max-width: calc(50% - px-to-rem(var(--paf-radio-checkbox-group-column-gap)));
    }

    @include mq($from: large) {
      flex-basis: calc(33.33% - px-to-rem(var(--paf-radio-checkbox-group-column-gap)));
      max-width: calc(33.33% - px-to-rem(var(--paf-radio-checkbox-group-column-gap)));
    }
  }
}

.fieldset {
  @include reset-fieldset;

  .legend-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    row-gap: px-to-rem(var(--paf-radio-checkbox-group-toggle-row-gap));
  }

  .legend {
    color: var(--paf-radio-checkbox-group-legend-color);
    font-size: px-to-rem(var(--paf-radio-checkbox-group-legend-font-size));
    font-weight: var(--paf-radio-checkbox-group-legend-font-weight);
    padding-right: px-to-rem(var(--paf-radio-checkbox-group-legend-padding-inline-end));
  }

  .legend-a11y {
    @include screen-reader-only;
  }

  slot {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: px-to-rem(var(--paf-radio-checkbox-group-column-gap));
    margin-block-start: px-to-rem(var(--paf-radio-checkbox-group-legend-margin-block-end));
  }

  .button {
    @include button-reset;

    cursor: pointer;
    font-size: px-to-rem(var(--paf-radio-checkbox-group-button-font-size));
    padding-block: px-to-rem(var(--paf-radio-checkbox-group-button-padding-block));
    padding-inline: px-to-rem(var(--paf-radio-checkbox-group-button-padding-inline));
    color: var(--paf-radio-checkbox-group-button-color);
    transition: color var(--paf-radio-checkbox-group-transition-duration);

    @include hover-style {
      color: var(--paf-radio-checkbox-group-button-color-active);
    }

    &:focus-visible {
      @include focus-visible;
    }

    @include reduced-motion {
      transition: none;
    }
  }
}
